
  export default {
    name: 'Tooltip',
    props: {
      title: {
        type: String,
        required: true
      },
      message: {
        type: String,
        required: true
      },
      buttonText: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        visible: false
      };
    },
    methods: {
      showTooltip() {
        this.visible = true;
        this.addOverlay();
      },
      hideTooltip() {
        this.visible = false;
        this.removeOverlay();
      },
      keepTooltipOpen() {
        this.visible = true;
      },
      handleClick() {
        this.$emit('button-click');
      },

      addOverlay() {
          //To do: Adjust dynamic relative class
        const cartContainer = document.querySelector('.cart-container-scroll');
        if (cartContainer) {
          cartContainer.classList.add('overlay-active');
        }
      },
      removeOverlay() {
        //To do: Adjust dynamic relative class
        const cartContainer = document.querySelector('.cart-container-scroll');
        if (cartContainer) {
          cartContainer.classList.remove('overlay-active');
        }
      }
    }
  };
  